export default "__VITE_ASSET__CxNKVG5n__"